import { Link } from "@root/shared/components/Link";
import { type FC } from "react";
import * as styles from "./styles.css";

type Props = {
  title: string;
  clientShopName: string;
  conditions: string;
  href: string;
};

export const SearchCondition: FC<Props> = ({ title, clientShopName, conditions, href }) => {
  return (
    <section className={styles.wrapper}>
      <div className={styles.leftCol}>
        <h1 className={styles.desiredJob}>
          {title}
          {clientShopName && <span>{clientShopName}</span>}
        </h1>
        <p>{conditions}</p>
      </div>
      <div className={styles.buttonOuter}>
        <Link theme="primary" href={href} className={styles.button}>
          この条件で検索する
        </Link>
      </div>
    </section>
  );
};
